import { getHost, getPublicEnvVars } from '@b-stock/fe-core/bstock-next/helpers'

export const getAppConfig = () => {
  const { PUBLIC_APP_ENV, PUBLIC_STRIPE_PUBLIC_KEY = '' } = getPublicEnvVars()
  const SERVICE_HOST_PAYMETHODS = getHost('PAYMETHODS')

  const paymentsMethodsUrl = `${SERVICE_HOST_PAYMETHODS}/v1`

  const appName = 'home-portal'
  const platform = '3MP'
  const env = PUBLIC_APP_ENV ?? 'prod'

  const stripe = {
    pKey: PUBLIC_STRIPE_PUBLIC_KEY,
  }

  const api = {
    payments: {
      credit: {
        createACHTransferAccount: `${paymentsMethodsUrl}/entities/:accountId/stripe/ach-credit-transfer`,
      },
      createStripeFinancialSession: `${paymentsMethodsUrl}/entities/:entityId/stripe/financial-session`,
      createSetupIntent: `${paymentsMethodsUrl}/entities/:entityId/stripe/setup-intent`,
      updateSetupIntent: `${paymentsMethodsUrl}/entities/:entityId/stripe/setup-intent/:setupIntentId/update`,
      updateStripeCustomer: `${paymentsMethodsUrl}/entities/:entityId/stripe/customers`,
    },
  }

  const serviceHosts = {
    paymentMethods: paymentsMethodsUrl,
  }

  return {
    appName,
    platform,
    env,
    stripe,
    api,
    serviceHosts,
  }
}
